import { CustomSwitch } from "../Toolbar/utils";
import { useBoundStore } from "useStore";
import { useShallow } from "zustand/react/shallow";

export default function AdsActiveSwitch({ row }) {
  const editAdsActive = useBoundStore((state) => state.editAdsActive);
  const activeData = useBoundStore(
    useShallow((state) => state.adsEditedRows[row.itemId]?.active),
  );

  const isActive = activeData?.value ?? row.active;

  return (
    <CustomSwitch
      checked={isActive}
      onChange={() => editAdsActive(row)}
      inputProps={{ "aria-label": "controlled" }}
      color="secondary"
    />
  );
}
